import {ISVG} from "../../common/Logo/Logo";

export interface IShape1Props extends Pick<ISVG, "fill"> {}

export const Shape8 = ({ fill }: IShape1Props) => {
    const _fill = fill ?? "white;";

    return (
        <svg
            width="582"
            height="85"
            viewBox="0 0 582 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M239.295 0.0434706C282.291 1.37217 318.447 31.5886 355.838 52.8552C390.152 72.3713 418.915 98.6672 451.605 120.795C488.411 145.709 542.267 153.179 562.507 192.748C582.685 232.195 553.063 280.139 555.735 324.366C558.323 367.21 591.192 409.211 578.049 450.072C564.809 491.238 517.702 510.487 486.308 540.224C458.551 566.515 433.557 594.907 402.141 616.693C369.887 639.059 335.897 658.511 298.509 670.454C259.053 683.058 218.081 689.468 176.667 688.716C132.078 687.908 85.5176 686.539 45.9977 665.874C6.11014 645.017 -28.2322 611.203 -48.4642 570.994C-68.3268 531.52 -54.032 483.076 -67.2063 440.896C-80.744 397.551 -129.018 365.113 -126.935 319.752C-124.876 274.931 -80.36 244.39 -56.4373 206.431C-34.2836 171.279 -20.5835 130.291 10.1151 102.29C40.8155 74.2874 81.9796 62.4949 119.927 45.5649C159.151 28.0657 196.366 -1.28317 239.295 0.0434706Z"
                fill={_fill}
            />
        </svg>
    );
};
